import React from 'react'
import {
    Backdrop,
    CircularProgress,
  } from "@mui/material";
function Loader({open}) {
  return (
    <>
     <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1+theme.zIndex.drawer + 2000 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

export default Loader
